import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';

import { getBackEndInstance } from '@tablesready/frontend-get-backend';

declare const process: {
  env: {
    LOCAL_IP: string;
    PORT: string;
    NODE_ENV: string;
    NATIVE_APP_HOST_URL: string;
  };
};

export interface ApiClientOptions {
  headers?: HttpHeaders | Record<string, string | string[]>;
  context?: HttpContext;
  observe?: 'body';
  params?: HttpParams | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;
  reportProgress?: boolean;
  responseType?: 'json' | 'text' | 'blob';
  withCredentials?: boolean;
}

@Injectable()
export class ApiClientService {
  private baseUrl = '';

  constructor(private readonly http: HttpClient) {
    this.baseUrl = this.getBackendUrl();
  }

  getBackendUrl(): string {
    if (
      Capacitor.isNativePlatform() &&
      process.env.NODE_ENV === 'production' &&
      process.env.NATIVE_APP_HOST_URL &&
      process.env.NATIVE_APP_HOST_URL !== ''
    ) {
      return process.env.NATIVE_APP_HOST_URL;
    }

    if (process.env.NODE_ENV === 'development' && process.env.LOCAL_IP) {
      return `http://${process.env.LOCAL_IP}:${process.env.PORT}`;
    }

    return getBackEndInstance();
  }

  get<T>(url: string, options?: ApiClientOptions): Observable<T> {
    // @ts-expect-error extra options
    return this.http.get<T>(this.baseUrl + url, options);
  }

  post<T>(url: string, body: unknown, options?: ApiClientOptions): Observable<T> {
    // @ts-expect-error extra options
    return this.http.post<T>(this.baseUrl + url, body, options);
  }

  patch<T>(url: string, body: unknown): Observable<T> {
    return this.http.patch<T>(this.baseUrl + url, body);
  }

  delete<T>(url: string, options?: ApiClientOptions): Observable<T> {
    // @ts-expect-error extra options
    return this.http.delete<T>(this.baseUrl + url, options);
  }

  put<T>(url: string, body: unknown, options?: ApiClientOptions): Observable<T> {
    // @ts-expect-error extra options
    return this.http.put<T>(this.baseUrl + url, body, options);
  }
}
